import React, { useState } from 'react';
import { ESSTabs } from '../Molecules/Tabs';

/**
 * TabsExample - Functional example of Tabs component
 * Shows tabbed interfaces with different variants
 */
const TabsExample = () => {
  const [activeTab, setActiveTab] = useState({
    default: 'tab1',
    pills: 'tab1',
    underline: 'tab1',
  });

  const handleTabChange = (variant, tabId) => {
    setActiveTab({ ...activeTab, [variant]: tabId });
  };

  const tabsData = [
    {
      variant: 'default',
      title: 'Default Tabs',
      tabs: [
        {
          id: 'tab1',
          label: 'Profile',
          content: 'User profile information and settings.',
        },
        {
          id: 'tab2',
          label: 'Account',
          content: 'Account details and preferences.',
        },
        {
          id: 'tab3',
          label: 'Security',
          content: 'Security settings and password management.',
        },
      ],
    },
    {
      variant: 'pills',
      title: 'Pills Tabs',
      tabs: [
        {
          id: 'tab1',
          label: 'Overview',
          content: 'Overview of your dashboard and recent activity.',
        },
        {
          id: 'tab2',
          label: 'Analytics',
          content: 'Detailed analytics and statistics.',
        },
        {
          id: 'tab3',
          label: 'Reports',
          content: 'Generated reports and exports.',
        },
      ],
    },
    {
      variant: 'underline',
      title: 'Underline Tabs',
      tabs: [
        {
          id: 'tab1',
          label: 'General',
          content: 'General settings and configuration.',
        },
        {
          id: 'tab2',
          label: 'Advanced',
          content: 'Advanced options and features.',
        },
        {
          id: 'tab3',
          label: 'About',
          content: 'About this application and version information.',
        },
      ],
    },
  ];

  return (
    <div className="tabs-example">
      {tabsData.map((tabGroup) => (
        <div key={tabGroup.variant} className="tabs-example__group">
          <h3>{tabGroup.title}</h3>
          <ESSTabs 
            dropdownBreakpoint={960} 
            dropdownLabel="Select a category to explore:" 
            variant={tabGroup.variant} 
            className="tabs-example__tabs" 
            minHeight="300px"
          >
            {/* Tab List */}
            <div role="tablist" className="tabs-example__tablist">
              {tabGroup.tabs.map((tab) => (
                <button
                  key={tab.id}
                  role="tab"
                  id={tab.id}
                  data-value={tab.id}
                  aria-selected={activeTab[tabGroup.variant] === tab.id}
                  data-selected={activeTab[tabGroup.variant] === tab.id}
                  onClick={() => handleTabChange(tabGroup.variant, tab.id)}
                  className="tabs-example__tab"
                >
                  {tab.label}
                </button>
              ))}
            </div>

            {/* Tab Panels */}
            {tabGroup.tabs.map((tab) => (
              <div
                key={tab.id}
                role="tabpanel"
                hidden={activeTab[tabGroup.variant] !== tab.id}
                className="tabs-example__panel"
              >
                {tab.content}
              </div>
            ))}
          </ESSTabs>
        </div>
      ))}

      <style jsx>{`
        .tabs-example__group {
          margin-bottom: 2rem;
          padding: 1rem;
          border: 1px solid var(--ess-color-border, #e5e7eb);
          border-radius: 0.5rem;
        }

        .tabs-example__group h3 {
          margin: 0 0 1rem 0;
          font-size: 1.125rem;
          font-weight: 600;
          color: var(--ess-color-text-primary, #1f2937);
        }

        .tabs-example__tabs {
          /* ESS Tabs wrapper handles styling */
        }

        .tabs-example__tablist {
          /* React Aria handles tablist styling through ESSTabs */
        }

        .tabs-example__tab {
          /* React Aria handles tab styling through ESSTabs */
        }

        .tabs-example__panel {
          padding: 1rem 0;
          color: var(--ess-color-text-primary, #1f2937);
          animation: fadeIn 0.2s ease-out;
        }

        .tabs-example__panel[hidden] {
          display: none;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(4px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default TabsExample;
